import type { ResultDetail } from '../../../../../../../../graphql/rest-link/types.ts';
import type { CustomResultEntry, SubstitutionMap } from './types.ts';

// Custom column tags carry their mapId, e.g. %DOG_NAME_CUSTOM_4954%
const CUSTOM_MERGE_TAG_REGEX = /%[A-Z0-9_]+_CUSTOM_(\d+)%/g;

type BuildCustomColumnSubstitutionsParams = {
  result: ResultDetail['result'];
  content: string;
};

const buildCustomColumnSubstitutions = ({
  result,
  content,
}: BuildCustomColumnSubstitutionsParams): SubstitutionMap => {
  const customTagMatches = [...content.matchAll(CUSTOM_MERGE_TAG_REGEX)];

  if (customTagMatches.length === 0) {
    return {};
  }

  const valuesByMapId = ((result.custom as CustomResultEntry[] | undefined) ?? []).reduce<
    Record<number, string>
  >((acc, { mapId, value }) => {
    acc[mapId] = value ?? '';
    return acc;
  }, {});

  return customTagMatches.reduce<SubstitutionMap>((acc, [tag, mapIdRaw]) => {
    acc[tag] = valuesByMapId[Number(mapIdRaw)] ?? '';
    return acc;
  }, {});
};

export default buildCustomColumnSubstitutions;
